var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "v2-outline-bd" }, _vm._l(_vm.innerCategoryList, function (category) {
    return _c('v2-outline-category', { key: category.id, attrs: { "category": category }, on: { "select": function select(cat) {
          return _vm.$emit('select', cat);
        } } });
  }), 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };